import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./tabGroup.html";
import { Routes } from '~/modules/routes';
import { navigate } from '~/modules/stores/routerStore';
import { upsertQueryParams } from '~/modules/utilities/router';
class TabGroup extends LightningElement {
  constructor(...args) {
    super(...args);
    this.tabs = void 0;
    this.responsiveState = {
      tabTypeStyle: 'display-7'
    };
    this._initialRender = true;
  }
  get mobile() {
    //LWC needs a getter whenever using a setter, even though the 'mobile' property is not being directly used inside the template
    return this.responsiveState;
  }
  set mobile(isMobile) {
    if (isMobile) {
      this.responsiveState.tabTypeStyle = 'display-8';
    } else {
      this.responsiveState.tabTypeStyle = 'display-7';
    }
  }
  // @ts-expect-error * Automated Type Error Fix
  changeTab(newTab) {
    navigate(`${Routes.LISTING}?${upsertQueryParams(['tab', newTab.code])}`);
  }

  // @ts-expect-error * Automated Type Error Fix
  handleTabKeydown(event) {
    switch (event.key) {
      case 'Tab':
        break;
      case 'ArrowLeft':
        this.selectPreviousTab();
        event.preventDefault();
        break;
      case 'ArrowRight':
        this.selectNextTab();
        event.preventDefault();
        break;
      default:
        event.preventDefault();
    }
  }
  selectPreviousTab() {
    const activeTab = this.tabs.filter(tab => tab.active)[0];
    const previousTabOrder = activeTab.order - 1 < 1 ? this.tabs.length : activeTab.order - 1;
    const previousTab = this.tabs.filter(tab => tab.order === previousTabOrder)[0];
    this.changeTab(previousTab);
  }
  selectNextTab() {
    const activeTab = this.tabs.filter(tab => tab.active)[0];
    const nextTabOrder = activeTab.order + 1 > this.tabs.length ? 1 : activeTab.order + 1;
    const nextTab = this.tabs.filter(tab => tab.order === nextTabOrder)[0];
    this.changeTab(nextTab);
  }

  /* This is going to be called from the parent component to set the right aria-controls attribute */
  // @ts-expect-error * Automated Type Error Fix
  setAriaControls(tabId, panelId) {
    this.template.querySelector(`a[id="${tabId}"]`)?.setAttribute('aria-controls', panelId);
  }

  /* This is going to be called from the parent component whenever a tab change is fired */
  focusActiveTab() {
    this.template.querySelector('li[active] > a')?.focus();
  }
  renderedCallback() {
    /* Dispatch anchor tags ids and aria-controls to be able to link them with tab panels for Accessibility */
    if (this._initialRender) {
      // @ts-expect-error * Automated Type Error Fix
      const tabsIds = [];
      this.template.querySelectorAll('a').forEach(a => {
        tabsIds.push(a.getAttribute('id'));
      });
      this.dispatchEvent(new CustomEvent('tabregister', {
        detail: {
          // @ts-expect-error * Automated Type Error Fix
          tabsIds: tabsIds,
          setAriaControls: this.setAriaControls.bind(this),
          focusActiveTab: this.focusActiveTab.bind(this)
        }
      }));
      this._initialRender = false;
    }
  }

  // @ts-expect-error * Automated Type Error Fix
  handleAnalytics(event) {
    event.detail.elementType = 'tab';
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(TabGroup, {
  publicProps: {
    tabs: {
      config: 0
    },
    mobile: {
      config: 3
    }
  },
  track: {
    responsiveState: 1
  },
  fields: ["_initialRender"]
});
const __lwc_component_class_internal = _registerComponent(TabGroup, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;